export default "__VITE_ASSET__B67dGwDH__"